module.exports = __webpack_public_path__ + "static/read180-e2fe901b9b9b36c46a2538c700af8616.png";